import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { LayoutDashboard, Building2, BookOpen, FileText } from "lucide-react";
import "./admin-layout.scss";
import { AdminSidebar } from "./admin-sidebar";
import { getBusinessId, isBusinessAdminUser } from "../../core/services/global-functions";

export default function AdminLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [navItems, setNavItems] = useState([]);
  useEffect(() => {
    // You can set initial state based on window width or other criteria
    setNavItems(setNavItemsValue());
  }, []);
  const setNavItemsValue = () => {
    let returnArray = [];
    if (isBusinessAdminUser() === true) {
      const dashboardUrl = `/business/organizations/${getBusinessId()}/performance`;
      const myDashboardUrl = `/business/organizations/${getBusinessId()}`;
      returnArray = [
        {
          id: "dashboard",
          href: dashboardUrl,
          label: "Dashboard",
          icon: LayoutDashboard,
        },
        {
          id: "organizations",
          href: myDashboardUrl,
          label: "My Organization",
          icon: Building2,
        },
        {
          id: "resources",
          href: "/business/resources",
          label: "Resources",
          icon: FileText,
        }
      ];
    } else {
      returnArray = [
        {
          id: "dashboard",
          href: "/admin/dashboard",
          label: "Dashboard",
          icon: LayoutDashboard,
        },
        {
          id: "organizations",
          href: "/admin/organizations",
          label: "Organizations",
          icon: Building2,
        },
        {
          id: "resources",
          href: "/admin/resources",
          label: "Resources",
          icon: FileText,
        },
        {
          id: "leadsManagement",
          href: "/admin/leads",
          label: "Manage Leads",
          icon: BookOpen,
        },
      ];
    }
    return returnArray;
  };
  const handleToggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };
  const setActiveTab = () => {
    const path = window.location.pathname;
    const activeItem = navItems.find((item) => path.startsWith(item.href));
    return activeItem ? activeItem.id : "";
  };
  return (
    <div className="page-bg">
      {/* Sidebar */}
      <AdminSidebar
        activeTab={setActiveTab()}
        isCollapsed={isCollapsed}
        onToggle={handleToggleSidebar}
        navItems={navItems}
      />
      {/* Main Content */}
      <div
        className={`main-content d-flex flex-column w-100 ${
          isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
}
